import { CopyValidationIssue, ICopyValidationState } from '../model/types'

interface IInitiativeWithEntryId {
  EntryId: number
}

export const getInitiativesNeedingValidation = <T extends IInitiativeWithEntryId>(
  selectedInitiatives: T[],
  validation: Record<number, ICopyValidationState>
): T[] =>
  selectedInitiatives.filter((initiative) => {
    const state = validation[initiative.EntryId]
    return (
      !state ||
      (state.status === 'invalid' &&
        state.issues.includes(CopyValidationIssue.DescriptionQualityUnavailable))
    )
  })
